var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('h2',{staticClass:"section-title",staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.subtitle)?_c('v-flex',[_c('h3',{staticClass:"sub-title"},[_c('v-icon',[_vm._v("mdi-subdirectory-arrow-right")]),_vm._v("\n      "+_vm._s(_vm.subtitle)+"\n    ")],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe52c38c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 